module.exports = __webpack_public_path__ + "img/4.ae0cf3b7.jpg";